<template>
  <div id="app-imagecropper">
    <div class="row">
      <div class="col-md-8">
        <input id="fileUpload" type="file" hidden @change="onFileChange" accept="image/*">
        <button  type="button" class="btn btn-success btn-md" @click="chooseFiles()">Pilih Gambar</button>
      </div>
    </div>
    <app-modal withCancel="true" v-if="showCropModal" @cancel="cancelCrop()" @ok="confirmCrop()" @hook:mounted="cropImage()">
      <img slot="body" :src="previewImageUrl" style="max-width:100%;" ref="previewImage" alt="previewImage">
    </app-modal>
  </div>
</template>
<script>
import Croppr from 'croppr'
import Modal from '@/components/plugins/Modal'

export default {
  name: 'app-imagecropper',
  components: {
    'app-modal': Modal
  },
  props: {
    aspectRatio: {
      type: Number,
      default: 1
    }
  },
  data: function() {
    return {
      url: null,
      showCropModal: false,
      previewImageUrl: null
    }
  },
  methods: {
    chooseFiles () {
      document.getElementById('fileUpload').click()
    },
    cropImage: function() {
      let _this = this
      let target = this.$refs.previewImage
      this.croppr = new Croppr(target, {
        aspectRatio: null
      })
    },
    cancelCrop: function() {
      this.croppr = null
      this.showCropModal = false
    },
    confirmCrop: function() {
      let _this = this
      let cropValue = this.croppr.getValue()
      let srcImage = this.$refs.previewImage

      let resizeRatio = 1
      if (cropValue.width > 1024) {
        resizeRatio = 1024 / cropValue.width
      }

      let canvas = document.createElement("canvas")
      canvas.height = cropValue.height * resizeRatio
      canvas.width = cropValue.width * resizeRatio

      let context = canvas.getContext('2d')
      context.drawImage(srcImage, cropValue.x, cropValue.y, cropValue.width, cropValue.height,
      0, 0, canvas.width, canvas.height)

      canvas.toBlob(function (blob) {
        var url = URL.createObjectURL(blob)
        _this.$emit('finished', {url: url, blob: blob})
      }, 'image/png')

      this.showCropModal = false
      this.croppr = null
    },
    onFileChange (e) {
      const file = e.target.files[0]
      const fileType = file['type']
      const validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/gif']
      if (!validImageTypes.includes(fileType)) {
        alert('hanya menerima tipe file gambar')
        this.selectedPicture = null
      } else {
        let _this = this
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function (e) {
          if (e.target.readyState == 2) {
            _this.showCropModal = true
            _this.previewImageUrl = e.target.result
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ImageCropper.vue?2c233ba8